import { Component, OnInit } from '@angular/core';
import { Subscription, Subject, Observable } from 'rxjs/';

import { RxComponent } from 'app/core/components/common/rx.component';
import { ActionClickEvent, BulkActionClickEvent } from 'app/shared/components/dynamic-grid/dynamic-grid.component';
import { NotificationService } from 'app/core/services/notification.service';
import { ConfigService } from 'app/core/services/config.service';
import { ProductSegmentService } from './product-segment.service';

import { SmartModalService } from 'app/core/services/smart-modal.service';

@Component({
  selector: 'itpx-product-segments',
  templateUrl: './product-segments.component.html',
  styleUrls: ['./product-segments.component.css']
})
export class ProductSegmentsComponent extends RxComponent implements OnInit {

    private url: string;
    private detailsRoute: string = '/agora/product-data/product-segments/{{key}}/details';
    private bulkActionsConfig: any;

    private fields: Array<any> = [
        {
            title: 'Code',
            name: 'code',
            config: {
                type: 'link',
                route: this.detailsRoute,
                key: 'id'
            }
        }, {
            title: 'Name',
            name: 'name',
            config: {
                type: 'link',
                route: this.detailsRoute,
                key: 'id'
            }
        }
    ];

    constructor(
        private configService: ConfigService,
        private service: ProductSegmentService,
        private modalService: SmartModalService
    ) {
        super();
        this.url = configService.get('server').url + configService.get('endpoints').agora.productSegments.list.api;
    }

    ngOnInit() {

    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/product-segments/product-segments.component.ts